import { render, staticRenderFns } from "./MessageForTeacher.vue?vue&type=template&id=90f9b094&scoped=true&"
import script from "./MessageForTeacher.vue?vue&type=script&lang=js&"
export * from "./MessageForTeacher.vue?vue&type=script&lang=js&"
import style0 from "./MessageForTeacher.vue?vue&type=style&index=0&id=90f9b094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f9b094",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
